import { useCreateResourceQueue, useDeleteResourceQueue } from '../../../hooks';

import { Card, Button } from '@pella/sash-framework';

import * as classes from './QueueCards.module.css';

/**
 * @type {Record<string, Pella.ProductionRequestAPI.ResourceQueueByStatus['queueStatus']>}
 */
const STATUS = { AVAILABLE: 'AVAILABLE', TEMPORARY: 'TEMPORARY' };

/**
 * Queue Cards molecule
 * @param {Local.QueueCardsProps} props - Component props
 */
export const QueueCards = ({ data }) => {
  const { mutate: createResourceQueue } = useCreateResourceQueue();
  const { mutate: deleteResourceQueue } = useDeleteResourceQueue();

  return (
    <div className={classes.container}>
      {data?.map(({ queueId, description, queueStatus }) => (
        <Card key={queueId} data-testid='queue-card' className={classes.card}>
          <div className={classes.title}>{description}</div>
          {queueStatus === STATUS.AVAILABLE && (
            <Button
              className={classes.button}
              onClick={() => createResourceQueue({ queueId, queueStatus: STATUS.TEMPORARY })}
            >
              Assign as Temporary
            </Button>
          )}
          {queueStatus === STATUS.TEMPORARY && (
            <Button className={classes.button} onClick={() => deleteResourceQueue({ queueId })}>
              Remove Assignment
            </Button>
          )}
        </Card>
      ))}
    </div>
  );
};
